var Sortable = window.Sortable;

$(document).on('ready', function () {
    function PhotoSort (element) {
        var self = this;
        self.root = element;
        self.ideabookId = $(self.root).data('ideabookId');
        self.sortUrl = $(self.root).data('sortUrl');

        self.movingPhoto = null;
        self.nextPhoto = null;

        self.sendQuery = function (data) {
            $.post(self.sortUrl, data)
            .fail(function () {
                var message = 'Что-то пошло не так, попробуйте позднее';
                window.Toasts.pushToast(message, 'fail', undefined, 5000);
            });
        };

        self.handleSort = function (movingId, ideabookId, nextId) {
            var data = {
                photo_id: movingId,
                ideabook_id: ideabookId
            };
            if (nextId) {
                data.next_photo_id = nextId;
            }
            self.sendQuery(data);
        };

        self.sortable = Sortable.create(
            self.root,
            (function () {
                return {
                    animation: 150,
                    delay: 25,
                    forceFallback: true,
                    filter: function (event, element) {
                        return $(element).is('[data-photo-sort-ignore]')
                    },
                    onStart: function (event) {
                        self.movingPhoto = self.root.children[event.oldIndex];
                    },
                    onEnd: function (event) {
                        self.nextPhoto = self.root.children[event.newIndex + 1];
                        var movingPhotoId = $(self.movingPhoto).data('photoId');
                        var nextPhotoId = self.nextPhoto ? $(self.nextPhoto).data('photoId') : null;
                        self.handleSort(movingPhotoId, self.ideabookId, nextPhotoId);
                        self.movingElement = null;
                        self.nextElement = null;
                    }
                };
            })()
        );
    };

    function SetMain (element) {
        var self = this;
        self.root = element;
        self.ideabookId = $(self.root).data('ideabookId');
        self.setMainUrl = $(self.root).data('setMainPhotoUrl');
        self.mainClass = $(self.root).data('setMainPhotoMainClass');
        self.$holders = $(self.root).find('.' + $(self.root).data('setMainPhotoHolder'));

        self.sendQuery = function (data, prevMainId) {
            $.post(self.setMainUrl, data)
            .fail(function () {
                var message = 'Что-то пошло не так, попробуйте позднее';
                window.Toasts.pushToast(message, 'fail', undefined, 5000);
                self.handleSetAsMain(prevMainId);
            });
        };

        self.handleSetAsMain = function (id, ideabookId, prevMainId) {
            var $nextActive;

            self.$holders.each(function (index, holder) {
                var $holder = $(holder);
                if ($holder.hasClass(self.mainClass)) {
                    if (!prevMainId) {
                        prevMainId = $holder.data('photoId');
                    }
                    $holder.removeClass(self.mainClass);
                }
                if ($holder.data('photoId') === id) {
                    $nextActive = $holder;
                }
            });

            if ($nextActive) {
                $nextActive.addClass(self.mainClass);
            }

            if (id && ideabookId) {
                var data = {
                    photo_id: id,
                    ideabook_id: ideabookId
                };
                self.sendQuery(data, prevMainId);
            }
        };

        self.$holders.each(function (index, holder) {
            var $holder = $(holder);
            var $button = $holder.find('.' + $(self.root).data('setMainPhotoButtonClass'));

            $button.on('click.SetMain', function () {
                self.handleSetAsMain($holder.data('photoId'), self.ideabookId);
            });
        });
    }

    var $photoSortRoot = $('[data-photo-sort]');
    $photoSortRoot.each(function (idx, element) {
        var component = new PhotoSort(element);
        $(element).data('photo-sort', component);
    });

    var $setMainRoot = $('[data-set-main-photo]');
    $setMainRoot.each(function (idx, element) {
        var component = new SetMain(element);
        $(element).data('set-main', component);
    });
});
